export const environment = {
  clientId: 'finance-spa'
};
